function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  fill: "#f4fbff",
  r: 148.886
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m343.924 135.849c18.061 24.639 28.734 55.033 28.734 87.924 0 82.227-66.658 148.886-148.886 148.886-32.891 0-63.285-10.673-87.924-28.734 27.091 36.959 70.815 60.962 120.151 60.962 82.227 0 148.886-66.658 148.886-148.886.001-49.337-24.003-93.061-60.961-120.152z",
  fill: "#e4f6ff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256 412.537c-86.315 0-156.537-70.222-156.537-156.537s70.222-156.537 156.537-156.537 156.537 70.222 156.537 156.537-70.222 156.537-156.537 156.537zm0-297.772c-77.877 0-141.234 63.357-141.234 141.234 0 77.878 63.357 141.235 141.234 141.235s141.234-63.357 141.234-141.234-63.357-141.235-141.234-141.235z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256 512c-78.938 0-152.265-35.6-201.178-97.671l24.037-18.942c41.992 53.288 104.411 84.42 171.917 85.95 125.599 2.845 228.78-96.388 230.596-222.007.324-22.421-2.625-44.569-8.758-65.858-.764-2.653.749-5.426 3.384-6.249l19.479-6.083c2.737-.855 5.634.717 6.432 3.471 6.698 23.109 10.091 47.098 10.091 71.389 0 68.38-26.629 132.667-74.98 181.019-48.353 48.352-112.64 74.981-181.02 74.981z",
  fill: "#b3e59f"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m15.922 328.908c-2.743.832-5.628-.761-6.403-3.52-6.318-22.491-9.519-45.807-9.519-69.388 0-68.38 26.629-132.667 74.98-181.019 48.353-48.352 112.64-74.981 181.02-74.981 78.92 0 152.236 35.586 201.15 97.634l-24.034 18.946c-43.073-54.639-107.63-85.976-177.116-85.976-124.284 0-225.396 101.112-225.396 225.396 0 20.658 2.784 41.073 8.281 60.761.743 2.66-.791 5.422-3.434 6.223z",
  fill: "#b3e59f"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m501.909 184.611c-.798-2.754-3.695-4.326-6.432-3.471l-10 3.123c6.765 23.216 10.192 47.325 10.192 71.737 0 68.38-26.629 132.667-74.98 181.019-46.438 46.439-107.578 72.824-172.922 74.841 2.738.086 5.481.14 8.233.14 68.38 0 132.667-26.629 181.019-74.981s74.981-112.639 74.981-181.019c0-24.291-3.393-48.28-10.091-71.389z",
  fill: "#95d6a4"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256 0c-16.62 0-32.995 1.586-48.962 4.662 9.424-1.04 18.958-1.586 28.578-1.586 78.92 0 152.236 35.586 201.15 97.634l-10.161 8.01c2.216 2.569 4.397 5.178 6.512 7.86l24.034-18.946c-48.915-62.048-122.231-97.634-201.151-97.634z",
  fill: "#95d6a4"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m463.088 129.101h-81.951c-2.817 0-5.101-2.284-5.101-5.101v-20.403c0-2.817 2.284-5.101 5.101-5.101h57.467v-57.466c0-2.817 2.284-5.101 5.101-5.101h20.403c2.817 0 5.101 2.284 5.101 5.101v81.951c-.001 3.38-2.741 6.12-6.121 6.12z",
  fill: "#b3e59f"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m464.108 35.929h-10.064v71.887c0 3.38-2.74 6.121-6.121 6.121h-71.887v10.064c0 2.817 2.284 5.101 5.101 5.101h81.951c3.38 0 6.121-2.74 6.121-6.121v-81.951c-.001-2.817-2.284-5.101-5.101-5.101z",
  fill: "#95d6a4"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m68.295 476.043h-20.403c-2.817 0-5.101-2.284-5.101-5.101v-81.951c0-3.38 2.74-6.121 6.121-6.121h81.951c2.817 0 5.101 2.284 5.101 5.101v20.403c0 2.817-2.284 5.101-5.101 5.101h-57.467v57.467c0 2.818-2.284 5.101-5.101 5.101z",
  fill: "#b3e59f"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m130.863 382.871h-9.437v10.966c0 2.817-2.284 5.101-5.101 5.101h-51.346c-3.38 0-6.121 2.74-6.121 6.121v51.346c0 2.817-2.284 5.101-5.101 5.101h-10.965v9.437c0 2.817 2.284 5.101 5.101 5.101h20.403c2.817 0 5.101-2.284 5.101-5.101v-57.467h57.467c2.817 0 5.101-2.284 5.101-5.101v-20.403c-.001-2.817-2.285-5.101-5.102-5.101z",
  fill: "#95d6a4"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m271.302 256h-30.604v-68.167c0-2.817 2.284-5.101 5.101-5.101h20.403c2.817 0 5.101 2.284 5.101 5.101v68.167z",
  fill: "#365e7d"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m266.201 182.732h-13.574c2.817 0 5.101 2.284 5.101 5.101v68.167h13.574v-68.167c0-2.818-2.284-5.101-5.101-5.101z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m361.903 271.302h-105.903v-30.604h105.903c2.817 0 5.101 2.284 5.101 5.101v20.403c0 2.816-2.284 5.1-5.101 5.1z",
  fill: "#365e7d"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m361.903 240.698h-8.694v11.709c0 2.817-2.284 5.101-5.101 5.101h-92.108v13.795h105.903c2.817 0 5.101-2.284 5.101-5.101v-20.403c0-2.818-2.284-5.101-5.101-5.101z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m276.625 256c0 5.514 10.78 10.71 8.374 15.27-5.49 10.405-16.416 17.497-28.999 17.497-18.097 0-32.767-14.67-32.767-32.767s14.67-32.767 32.767-32.767c12.441 0 23.263 6.934 28.812 17.148 2.522 4.643-8.187 9.964-8.187 15.619z",
  fill: "#365e7d"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m270.644 226.689c2.207 4.408 3.456 9.379 3.456 14.644 0 18.097-14.67 32.767-32.767 32.767-5.265 0-10.236-1.249-14.644-3.456 5.378 10.743 16.48 18.123 29.311 18.123 18.097 0 32.767-14.67 32.767-32.767 0-12.832-7.38-23.933-18.123-29.311z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 146.424,
  cy: 257.964,
  fill: "#e4f6ff",
  r: 9.518
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 162.087,
  cy: 312.489,
  fill: "#e4f6ff",
  r: 9.518
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 202.913,
  cy: 351.877,
  fill: "#e4f6ff",
  r: 9.518
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 257.964,
  cy: 365.575,
  fill: "#e4f6ff",
  r: 9.518
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 312.489,
  cy: 349.913,
  fill: "#e4f6ff",
  r: 9.518
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 351.877,
  cy: 309.087,
  fill: "#e4f6ff",
  r: 9.518
})), /*#__PURE__*/React.createElement("path", {
  d: "m249.765 370.393c1.655 2.81 4.702 4.701 8.199 4.701 5.066 0 9.195-3.961 9.49-8.953-5.756 1.764-11.659 3.19-17.689 4.252z",
  fill: "#d3effb"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 349.913,
  cy: 199.511,
  fill: "#e4f6ff",
  r: 9.518
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 309.087,
  cy: 160.123,
  fill: "#e4f6ff",
  r: 9.518
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 254.036,
  cy: 146.424,
  fill: "#e4f6ff",
  r: 9.518
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 199.511,
  cy: 162.087,
  fill: "#e4f6ff",
  r: 9.518
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 160.123,
  cy: 202.913,
  fill: "#e4f6ff",
  r: 9.518
})), /*#__PURE__*/React.createElement("g", {
  fill: "#d3effb"
}, /*#__PURE__*/React.createElement("path", {
  d: "m317.248 358.156c4.552-2.628 6.112-8.449 3.484-13.002-1.184-2.05-3.017-3.487-5.088-4.214-4.056 3.184-8.286 6.155-12.664 8.912-.012 1.638.388 3.299 1.266 4.82 2.628 4.552 8.449 6.112 13.002 3.484z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m356.636 300.844c-1.485-.857-3.105-1.262-4.705-1.269-2.708 4.568-5.644 8.984-8.809 13.22.778 1.842 2.131 3.458 3.996 4.535 4.552 2.628 10.374 1.069 13.002-3.484s1.069-10.374-3.484-13.002z"
})));

var SvgHistory = function SvgHistory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHistory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/history.f4af5134.svg";
export { ForwardRef as ReactComponent };